import type { DraftPickStarsResponse } from '@on3/api';
import { StarRating } from '@public/components/UI/StarRating/StarRating';
import { Text } from '@public/components/UI/Typography/Text';

import styles from './PicksByStars.module.scss';

interface IPicksByStarsProps {
  starPicks: DraftPickStarsResponse;
  picksTitle?: string;
}

export const PicksByStars = ({ starPicks, picksTitle }: IPicksByStarsProps) => {
  const { fiveStars, fourStars, threeStars, total } = starPicks;

  return (
    <section>
      <header className={styles.header}>
        <Text className={styles.starTitle} variant="h1">
          {picksTitle}
        </Text>
      </header>
      <div className={styles.starWrapper}>
        <div className={styles.starContainer}>
          <Text component="h3" variant="h1">
            {fiveStars}
          </Text>
          <Text className={styles.name} variant="subtitle1">
            5-stars
          </Text>
          <StarRating stars={5} />
        </div>
        <div className={styles.starContainer}>
          <Text component="h3" variant="h1">
            {fourStars}
          </Text>
          <Text className={styles.name} variant="subtitle1">
            4-stars
          </Text>
          <StarRating stars={4} />
        </div>
        <div className={styles.starContainer}>
          <Text component="h3" variant="h1">
            {threeStars}
          </Text>
          <Text className={styles.name} variant="subtitle1">
            3-stars
          </Text>
          <StarRating stars={3} />
        </div>
        <div className={styles.totalContainer}>
          <Text component="h3" variant="h1">
            {total}
          </Text>
          <Text className={styles.name} variant="subtitle1">
            <span className={styles.total}>Total </span>
            <span>Star Rated Draft Picks</span>
          </Text>
        </div>
      </div>
    </section>
  );
};
